import { BaseLayoutContext, DailyMessageContent } from '../types/base-layout'
import { BaseRegionResponse } from '../types/region-response'
import { BasePhoto, MissionStory, PrayerRequest } from '../types/base-content'
import { PartnerRegionAssociation } from '@/features/partners/types/partner.type'

interface BuildContextOptions {
  permissions?: BaseLayoutContext['permissions']
  meta?: BaseLayoutContext['meta']
  actions?: BaseLayoutContext['actions']
}

export function buildBaseLayoutContext(
  region: BaseRegionResponse,
  photos: BasePhoto[] = [],
  missionStories: MissionStory[] = [],
  prayerRequests: PrayerRequest[] = [],
  partners: PartnerRegionAssociation[] = [],
  options: BuildContextOptions = {},
): BaseLayoutContext {
  return {
    region: {
      id: region.id,
      name: region.name,
    },
    dailyMessages: {},
    photos,
    missionStories,
    prayerRequests,
    partners,
    permissions: options.permissions,
    meta: options.meta,
    actions: options.actions,
  }
}
